<div class="page-wrapper" [ngClass]="layoutClass">
  <div class="row m-0">
    <div class="col-12 p-0">
      <header class="header">
        <img
          class="header-logo"
          src="assets/images/logo/logo.svg"
          alt="" />
      </header>
      <div class="breadcrumb">
        <h4 class="breadcrumb-event-type"> {{ breadcrumbProps.preTitle }}</h4>
        <h4 class="breadcrumb-title"> {{ breadcrumbProps.title }}</h4>
      </div>
    </div>
  </div>
  <div class="page-body-wrapper">
    <!-- <div class="sidebar-wrapper" [class.close_icon]="navService.collapseSidebar" [attr.data-layout]="layout.config.settings.icon">
      <app-sidebar></app-sidebar>
    </div> -->
    <div class="page-body-style-2">
      <router-outlet></router-outlet>
    </div>
    <footer class="footer" [class.footer-dark]="footerDark" [class.footer-light]="footerLight" [class.footer-fix]="footerFix">
      <app-footer></app-footer>
    </footer>
  </div>
</div>
